<script lang="ts">
  import { AssetPaths } from '../../assets/asset-store';
  import { BASE_HEALTH } from '../../game/constants/hud';

  const { blue, red, max }: { blue: number; red: number; max: number } = $props();

  const { origin, fillFraction, text, colors } = BASE_HEALTH;

  // Both bars stop short of the frame's inner edge, which is what `fillFraction` is for.
  const blueWidth = $derived(Math.min(1, blue / max) * fillFraction * 100);
  const redWidth = $derived(Math.min(1, red / max) * fillFraction * 100);
</script>

<!--
  Two bars either side of centre under `BaseHP.png`. Blue fills right-to-left so both bars grow
  outward from the middle.

  The original drew its numbers twice, once under the frame art and once over it, because the art is
  translucent where they sit. Here the art is a sibling with a lower stacking order and the numbers
  are drawn once on top — same result, half the drawing.
-->
<div
  class="bases"
  style:left="calc(50% + {origin.xFromCentre}px)"
  style:top="{origin.y}px"
  style:width="{origin.width}px"
  style:height="{origin.height}px"
>
  <div class="bases__track" style:height="{origin.height / 2 + BASE_HEALTH.barExtraHeight}px">
    <div class="bases__half">
      <div class="bases__fill bases__fill--blue" style:width="{blueWidth}%"></div>
    </div>
    <div class="bases__half">
      <div class="bases__fill" style:width="{redWidth}%" style:background={colors[1]}></div>
    </div>
  </div>

  <img
    class="bases__frame"
    src={AssetPaths.ui('BaseHP')}
    alt=""
    style:left="{BASE_HEALTH.imageOffset.x}px"
    style:top="{BASE_HEALTH.imageOffset.y}px"
    style:width="{origin.width}px"
    style:height="{origin.height * 2}px"
  />

  <span
    class="hud-text bases__value bases__value--blue"
    style:font-size="{text.font}px"
    style:top="{origin.height / 2 + text.offsetYOver}px"
    data-testid="blue-base-health">{blue}</span
  >
  <span
    class="hud-text bases__value bases__value--red"
    style:font-size="{text.font}px"
    style:top="{origin.height / 2 + text.offsetYOver}px"
    data-testid="red-base-health">{red}</span
  >
</div>

<style>
  .bases {
    position: absolute;
  }

  .bases__track {
    position: absolute;
    top: 6px;
    left: 0;
    display: flex;
    width: 100%;
  }

  .bases__half {
    position: relative;
    flex: 1;
    height: 100%;
    background: rgb(17 17 17 / 30%);
  }

  .bases__fill {
    position: absolute;
    top: 0;
    height: 100%;
    background: #a44e36;
  }

  /* Blue is anchored to the right of its own half, so it drains towards the centre. */
  .bases__fill--blue {
    right: 0;
    background: #465e84;
  }

  .bases__frame {
    position: absolute;
    pointer-events: none;
  }

  .bases__value {
    color: #465e84;
  }

  .bases__value--blue {
    right: calc(50% + 6px);
    color: #465e84;
  }

  .bases__value--red {
    left: calc(50% + 6px);
    color: #a44e36;
  }
</style>
